<template>
    <form>
          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="12"
              sm="10"
              md="6"
            >
              <v-card class="elevation-12" ref="form">
                <v-toolbar
                  color="teal darken-4"
                  dark
                  flat
                >
                  <v-toolbar-title>Healthcare Provider Form</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="green"
                        v-on="on"
                        to='/login'
                      >
                        <span>Login</span>
                        <v-icon>mdi-login</v-icon>
                      </v-btn>

                    </template>
                    <span>Got an existing account? Login to your account</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text>
                <v-text-field
                    v-model="lastName"
                    :error-messages="lastNameErrors"
                    label="Last Name"
                    placeholder="Cruz"
                    required
                    @input="$v.lastName.$touch()"
                    @blur="$v.lastName.$touch()"
                ></v-text-field>
                <v-text-field
                    v-model="firstName"
                    :error-messages="firstNameErrors"
                    label="First Name"
                    placeholder="Juan"
                    required
                    @input="$v.firstName.$touch()"
                    @blur="$v.firstName.$touch()"
                ></v-text-field>
                <v-text-field
                    v-model="middleName"
                    :error-messages="middleNameErrors"
                    label="Middle Name"
                    placeholder="Andrade"
                    required
                    @input="$v.middleName.$touch()"
                    @blur="$v.middleName.$touch()"
                ></v-text-field>
                <v-text-field
                    v-model="email"
                    :error-messages="emailErrors"
                    label="E-mail"
                    placeholder="juandelacruz@gmail.com"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                ></v-text-field>
               <v-text-field
                    v-model="password"
                    :type="'password'"
                    :error-messages="passwordErrors"
                    label="Password"
                    placeholder="At least 8 characters with mix of symbols and numbers"
                    required
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()"
                ></v-text-field>
                <v-text-field
                    v-model.lazy="confirmPassword"
                    :type="'password'"
                    :error-messages="confirmPasswordErrors"
                    label="Confirm Password"
                    placeholder="Must be same password above"
                    required
                    @input="$v.confirmPassword.$touch()"
                    @blur="$v.confirmPassword.$touch()"
                ></v-text-field>
                <v-select 
                    v-model="role"
                    :items="roles"
                    :error-messages="roleErrors"
                    label="Profession"
                    required
                    @change="$v.role.$touch()"
                    @blur="$v.role.$touch()"
                ></v-select>
                <v-text-field
                      v-model="mobileNum"
                      :type="'mobileNum'"
                      :error-messages="mobileNumErrors"
                      label="Mobile Number"
                      placeholder="+639171234567"
                      required
                      @input="$v.mobileNum.$touch()"
                      @blur="$v.mobileNum.$touch()"
                  ></v-text-field>
                <v-text-field
                    v-model="meetingUrl"
                    :error-messages="meetingUrlErrors"
                    placeholder="Personal meeting link (Zoom, Google Meets, Microsoft Teams)"
                    label="Meeting Link"
                    @input="$v.meetingUrl.$touch()"
                    @blur="$v.meetingUrl.$touch()"
                    required
                ></v-text-field>

                <picture-input 
                  ref="pictureInput"
                  width="200" 
                  height="200" 
                  margin="16" 
                  accept="image/jpeg,image/png" 
                  size="10" 
                  button-class="btn"
                  :custom-strings="{
                    upload: '<h1>PRC ID!</h1>',
                    drag: 'Input PRC ID 💳 --You could also do drag and drop)'
                  }"
                  @change="onChange">
                </picture-input>                    


                </v-card-text>
                <v-card-actions>
                    <v-btn @click="clear">
                      <span>
                        <v-icon>mdi-close-circle-outline</v-icon>
                        clear
                      </span>
                    
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="orange darken-4" dark @click="submit">
                    <span> submit
                      <v-icon>mdi-send</v-icon>
                    </span>
                    </v-btn>
                </v-card-actions>              
              </v-card>
            </v-col>
          </v-row>

    </form>
</template>

<script>
  import PictureInput from 'vue-picture-input'
  import { EventBus } from '../utils'
  import { validationMixin } from 'vuelidate'
  import { post_image, post_service_provider, check_username } from '../api'
  import { required, maxLength, email } from 'vuelidate/lib/validators'
  export default {
    components: {
      PictureInput
    },
    mixins: [validationMixin],
    validations() {
      return {
        lastName: { required, minLength: maxLength(2) },
        firstName: { required, minLength: maxLength(2) },
        middleName: { required, minLength: maxLength(2) },
        email: { 
          required, 
          email,
          async isUnique(value) {
            // standalone validator ideally should not assume a field is required
            if (value === '') return true
            
            const response = await check_username({username: value})
            return Boolean(response.data.status)

          }
        },
        mobileNum: { required },
        meetingUrl: { required },
        role: { required },
        password: { required },
        confirmPassword: { required },
      }
    },
    data: () => ({
      profile_image_url: '',
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      meetingUrl: '',
      password: '',
      confirmPassword: '',
      mobileNum: '',
      role: '',
      roles: [
        'Counselor',
        'Psychologist',
        'Psychiatrist',

      ]
    }),
    computed: {
      mobileNumErrors () {
        const errors = []
        if (!this.$v.mobileNum.$dirty) return errors
        !this.$v.mobileNum.required && errors.push('Mobile Number is required')
        return errors
      },
      roleErrors () {
        const errors = []
        if (!this.$v.role.$dirty) return errors
        !this.$v.role.required && errors.push('Profession is required')
        return errors
      },

      firstNameErrors () {
        const errors = []
        if (!this.$v.firstName.$dirty) return errors
        !this.$v.firstName.required && errors.push('First Name is required.')
        return errors
      },
      lastNameErrors () {
        const errors = []
        if (!this.$v.lastName.$dirty) return errors
        !this.$v.lastName.required && errors.push('Last Name is required.')
        return errors
      },
      middleNameErrors () {
        const errors = []
        if (!this.$v.middleName.$dirty) return errors
        return errors
      },
      meetingUrlErrors () {
        const errors = []
        if (!this.$v.meetingUrl.$dirty) return errors
        !this.$v.meetingUrl.required && errors.push('Meeting URL is required.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        !this.$v.email.isUnique && errors.push('E-mail already taken')
        return errors
      },
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Password is required')
        return errors
      },
      confirmPasswordErrors () {
        const errors = []
        if (!this.$v.confirmPassword.$dirty) return errors
        this.confirmPassword && this.confirmPassword != this.password && errors.push('Password not matched')
        !this.$v.password.required && errors.push('Supply Password is required')
        return errors
      }

    },
    methods: {
      onChange (image) {
        if (image) {
          post_image(image).then(response => {
            this.profile_image_url = response.data.url
          })
        }
        
      },
      submit () {
        this.$v.$touch()

        const user_account = {
          profile_image_url: this.profile_image_url,
          last_name: this.lastName,
          middle_name: this.middleName,
          first_name: this.firstName,
          username: this.email, // use email as the username in the payload
          password: this.password,
          role: this.role,
          mobile_number: this.mobileNum
        }
        const provider_details = {
          meeting_url: this.meetingUrl
        }

        post_service_provider({
            user_account,
            provider_details
        })
            .then(()=> this.$router.push('/'))

      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.mobileNum = ''
        this.password = ''
        this.confirmPassword = ''
      },
    },
    mounted() {
        EventBus.$on('failedRegistering', (msg) => {
            this.errorMsg = msg
        })
    },
    beforeDestroy() {
        EventBus.$off('failedRegistering')
    }
  }
  </script>

<style>

</style>>